import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const Login = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const r = await login(form.email, form.password);
    setLoading(false);
    if (r.ok) nav("/identify");
    else setError(r.error);
  };

  return (
    <div className="grid md:grid-cols-2 gap-10 items-stretch min-h-[70vh]">
      <div className="relative panel overflow-hidden hidden md:block">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1564833840938-2f5041df082d')",
            backgroundSize: "cover", backgroundPosition: "center",
            filter: "grayscale(50%)",
          }}
        />
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative z-10 p-10 h-full flex flex-col justify-end">
          <span className="tag-chip">Return to Bay</span>
          <h2 className="font-display text-5xl uppercase text-cream mt-3 leading-none">Back<br />in the<br /><span className="text-red-candy">saddle.</span></h2>
        </div>
      </div>

      <form onSubmit={submit} className="panel p-8 md:p-10 flex flex-col justify-center" data-testid="login-form">
        <p className="font-mono text-xs tracking-widest text-amber-brass uppercase">// Access</p>
        <h1 className="font-display text-4xl uppercase text-cream mt-1 mb-8">Sign In</h1>

        <label className="font-mono text-xs uppercase tracking-widest text-secondary">Email</label>
        <input
          data-testid="login-email"
          className="data-input mt-1 mb-5"
          type="email" required autoComplete="email"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
        />
        <label className="font-mono text-xs uppercase tracking-widest text-secondary">Password</label>
        <input
          data-testid="login-password"
          className="data-input mt-1 mb-6"
          type="password" required autoComplete="current-password"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
        />

        {error && (
          <div data-testid="login-error" className="mb-4 border border-[var(--accent-red)] bg-[rgba(217,32,39,0.1)] text-cream font-mono text-xs px-3 py-2">
            {error}
          </div>
        )}

        <button data-testid="login-submit" disabled={loading} className="chrome-btn w-full mt-1">
          {loading ? "Cranking…" : "Sign In"}
        </button>
        <p className="mt-6 text-sm text-secondary text-center">
          New to the shop? <Link to="/register" data-testid="link-register" className="text-amber-brass underline">Get your keys</Link>
        </p>
      </form>
    </div>
  );
};

export default Login;
